var membersWorks = function () {
    let elements = $('.member-works');

    if(elements.length){
        for(let i=0; i < elements.length; i++){
            $(elements[i]).magnificPopup({
                delegate: '.work-item',
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                mainClass: 'mfp-with-zoom mfp-img-mobile',
                image: {
                    verticalFit: true,
                    titleSrc: function(item) {
                        return  item.el.attr('data-title') + '<br>' + item.el.attr('data-content');
                    }
                },
                gallery: {
                    enabled: true
                },
                zoom: {
                    enabled: true,
                    duration: 300, // don't foget to change the duration also in CSS
                    opener: function(element) {
                        return element.find('img');
                    }
                },
                callbacks: {
                    open: function() {
                        $('html').css('margin-right', 0);
                        $('html').css('overflow', 'visible');
                    },
                    change: function() {
                        var mfp = $.magnificPopup.instance;
                        var container = $(mfp.container);

                        if (mfp.index >= mfp.items.length - 1) container.addClass('mfp-last');
                        else container.removeClass('mfp-last');
                        if (mfp.index == 0) container.addClass('mfp-first');
                        else container.removeClass('mfp-first');
                    }
                }

            });
        }
    }

}

export default membersWorks;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/membersWorks.js